'use strict';
import {LightBoxStructure} from './lightbox/LightBoxStrucutre'
import {ScrollBar} from "./bootstrap/helper/ScrollBar";

class LightBox extends LightBoxStructure {
  constructor() {
    super();
    this.lightBoxModal = null;
    this.slideIndex = 1;
    this.lightBox = [];
    this.body = document.body;

    this.findAllLightBox();
    this.addEventClickToActiveModal();
  }

  findAllLightBox() {
    document.querySelectorAll(`[${this.dataHookAttribute}]`).
      forEach((item) => {
        let name = item.dataset.lightbox;
        if (!this.lightBox.includes(name)) {
          this.lightBox.push(name);
        }
      });
  }

  addEventClickToActiveModal() {
    this.lightBox.forEach(attributeValue => {
      let data = document.querySelectorAll(`[${this.dataHookAttribute}="${attributeValue}"]`);

      data.forEach((item, index) => {
        item.addEventListener('click', (e) => {
          ScrollBar.disable();
          e.preventDefault();
          setTimeout(() => {
            this.openModal(data, attributeValue);
            this.showSlides(index + 1);
          }, 10);
        });
      });
    });
  }

  openModal(data) {
    this.body.appendChild(this.createModal(data));
    this.lightBoxModal = document.querySelector('.' + this.mainBlock);
    this.lightBoxModal.style.display = 'block';

    let prev = document.querySelector('.' + this.block.arrow.prev);
    let next = document.querySelector('.' + this.block.arrow.next);
    let close = document.querySelector('.' + this.block.close);
    let delta = 0;
    let touchStart = null;

    prev.addEventListener('click', () => {
      this.plusSlides(-1);
    });
    next.addEventListener('click', () => {
      this.plusSlides(+1);
    });
    close.addEventListener('click', () => {
      this.lightBoxModal.style.display = 'none';
      this.destroyModal();
    });
    this.lightBoxModal.addEventListener('wheel', (e) => {
      if (e.deltaY < 0) {
        delta++;
        if (delta > 7) {
          this.plusSlides(-1);
          delta = 0;
        }
      } else {
        delta++;
        if (delta > 6) {
          this.plusSlides(+1);
          delta = 0;
        }
      }
    });
    this.lightBoxModal.addEventListener('click', (e) => {
      this.closeModalClickOutOfArea(e);
    });
    this.lightBoxModal.addEventListener('touchstart', (e) => {
      touchStart = e.changedTouches[0];
    });
    this.lightBoxModal.addEventListener('touchend', (e) => {
      let touchEnd = e.changedTouches[0];

      if (touchEnd.screenX - touchStart.screenX > 0) {
        this.plusSlides(+1);
      } else if (touchEnd.screenX - touchStart.screenX < 0) {
        this.plusSlides(-1);
      }
    });
    document.addEventListener('keyup', (e) => {
      let code = e.code;

      if (this.lightBoxModal) {
        if (code === 'Escape') {
          this.destroyModal();
        } else if (code === 'ArrowLeft') {
          this.plusSlides(-1);
        } else if (code === 'ArrowRight') {
          this.plusSlides(+1);
        }
      }
    });
  }

  showSlides(n) {
    let i;
    let columns = document.querySelectorAll('.' + this.block.columnWrapper);
    this.slideIndex = n;

    if (n > columns.length) {this.slideIndex = 1;}
    if (n < 1) {this.slideIndex = columns.length;}
    for (i = 0; i < columns.length; i++) {
      columns[i].classList.remove(this.block.active);
      columns[i].firstElementChild.classList.remove(this.block.columnActive);
    }

    columns[this.slideIndex - 1].classList.add(this.block.active);

    setTimeout(() => {
      columns[this.slideIndex - 1].firstElementChild.classList.add(this.block.columnActive);
    }, 100);
  }

  plusSlides(n) {
    this.showSlides(this.slideIndex += n);
  }

  destroyModal() {
    if (this.lightBoxModal) {
      this.lightBoxModal.remove();
      this.lightBoxModal = undefined;
      ScrollBar.enable();
    }
  }

  closeModalClickOutOfArea(e) {
    let className = e.target.className;

    if (className !== this.block.arrow.next
        && className !== this.block.arrow.prev
        && className !== this.block.close
    ) {

      let column = this.lightBoxModal.querySelector(`.${className}`);
      column = column.closest(`.` + this.block.column);

      if (!column) {
        this.destroyModal();
      }
    }
  }
}

new LightBox();